<template>
  <div class="expandable">
    <div @click="toggle" class="expandable-heading" :style="{ padding: customPadding }">
      <!-- @slot The content to show when collapsed. -->
      <slot name="header" v-bind:open="openInternal"></slot>
    </div>
    <div ref="expandableContent" class="expandable-content-container">
      <div class="expandable-content" :class="{ 'expandable-content-collapsed': !openInternal }">
        <!-- @slot The content to put in the expandable section. -->
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import smoothReflow from '@/plugins/smoothReflow';

export default {
  mixins: [smoothReflow],

  props: {
    /**
     * Boolean to indicate if the component is expanded.
     */
    open: {
      type: Boolean,
      default: false,
    },
    /**
     * Add a custom padding value to expandable headings
     */
    customPadding: {
      type: String,
      default: 'var(--space-4) var(--space-6) var(--space-4) var(--space-6)',
    },
  },

  data() {
    return {
      openInternal: this.open,
    };
  },

  created() {},

  mounted() {
    this.$smoothReflow({
      el: this.$refs.expandableContent,
    });
  },

  methods: {
    toggle() {
      this.openInternal = !this.openInternal;
      /**
       * Event emitted when the component is expanded or collapsed.
       * @property {Boolean} open True if component is expanded, false if it is collapsed.
       */
      this.$emit('toggle', this.openInternal);
    },
  },

  watch: {
    open: {
      handler(open) {
        this.openInternal = open;
      },
    },
  },
};
</script>
<style lang="postcss">
.expandable {
  .expandable-heading {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }

  .expandable-content-container {
    overflow: hidden;
  }

  .expandable-content {
    height: auto;
    transition: height 100ms ease-out;
    padding-left: var(--space-6);
  }

  .expandable-content-collapsed {
    height: 0px;
  }
}
</style>
